import React, { useContext, useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { requestMyProfile } from 'api/user'
import { AuthContext } from 'providers/auth'
import { setDatadogRumUser, clearDatadogRumUser } from 'utils/datadogRum'

const EMPTY_PROFILE = {
  Role: {},
  Country: { iba_active: false },
  KbaPartners: [],
  firstName: '',
  lastName: '',
  id: ''
}

export const ProfileContext = React.createContext({})

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(() => ({ ...EMPTY_PROFILE }))
  const { isAuthenticated } = useContext(AuthContext)

  const updateMyProfile = () => {
    requestMyProfile().then((newProfile) => {
      if (!newProfile?.id) {
        return
      }
      // Ensure Country and KbaPartners are properly structured
      const enhancedProfile = {
        ...newProfile,
        Country: newProfile.Country || { iba_active: false },
        KbaPartners: newProfile.KbaPartners || []
      }
      setProfile(enhancedProfile)
      setDatadogRumUser(enhancedProfile)
    })
  }

  useEffect(() => {
    if (isAuthenticated) {
      updateMyProfile()
    } else {
      clearDatadogRumUser()
      setProfile({ ...EMPTY_PROFILE })
    }
  }, [isAuthenticated])

  const contextValue = useMemo(() => ({
    profile,
    updateMyProfile
  }), [profile])

  if (isAuthenticated && !profile.id) {
    return null
  }
  return (
    <ProfileContext.Provider value={contextValue}>
      {children}
    </ProfileContext.Provider>
  )
}
ProfileProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default ProfileProvider
